import Router from "../router/router";
import GoodsType from "../enum/GoodsType";
import MyRouter from "../router/router";
import NewsMenuType from "enum/NewsMenuType.js";


class MyHistory {
    history = undefined

    constructor({history}) {
        this.history = history;
    }

    // 去商品详情
    toGoodsInfo({goodsType, id, startTime, endTime, isReplace = false}) {
        const pddShop = goodsType === GoodsType.PDD

        const search = new URLSearchParams({
            goodsType,
            startTime,
            endTime
        }).toString()

        if (isReplace) {
            this.history.replace({
                pathname: `${Router.GoodsInfo.realPath}/${pddShop}/${id}`,
                search
            });
        } else {
            this.history.push({
                pathname: `${Router.GoodsInfo.realPath}/${pddShop}/${id}`,
                search
            });
        }
    }

    toSearchPage({categoryId, keyword, goodsType, selfFlag}) {
        const search = new URLSearchParams({
            categoryId,
            keyword,
            goodsType,
            selfFlag
        }).toString()
        this.history.push({
            pathname: MyRouter.Search.path,
            search
        })
    }

    push({pathname, search}) {
        return this.history.push({
            pathname,
            search
        })
    }
}

class MyRouterUtil {
    build({history}) {
        return new MyHistory({history})
    }
}

export default new MyRouterUtil();